import { render, staticRenderFns } from "./BookmarkButton.htm?vue&type=template&id=5537d417&scoped=true&"
import script from "./BookmarkButton.ts?vue&type=script&lang=js&"
export * from "./BookmarkButton.ts?vue&type=script&lang=js&"
import style0 from "./BookmarkButton.scss?vue&type=style&index=0&id=5537d417&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5537d417",
  null
  
)

export default component.exports